// @flow strict

import { apiUrl } from '../../../core/api/apiConfig';
import { createAxiosInstance } from '../../../core/api/apiClient';
import type {
  JobTitleGroup,
  Location,
  ProvisioningStatusResponse,
  SignupData,
  CompleteSignupData,
} from './types';

const identityApiInstance = createAxiosInstance(apiUrl.identityBaseUrl);
const kenticoFreeTrialInstance = createAxiosInstance(apiUrl.kenticoFreeTrial);

export const profile = {
  getJobTitle: () =>
    identityApiInstance.get<{ jobTitleGroups: JobTitleGroup[] }>(
      '/reference-data-api/v1/jobtitlegroups',
    ),
  searchLocation: (locationName: string) =>
    identityApiInstance.get<{ locations: Location[] }>(
      `/reference-data-api/v1/locations?search=${locationName}`,
    ),
  create: (userData: SignupData) =>
    identityApiInstance.post<SignupData, void>('/signup/v1', userData),
  completeSignup: (completeSignupData: CompleteSignupData) =>
    identityApiInstance.post<CompleteSignupData, void>('/signup/v1/complete', completeSignupData),
};

export const provisioning = {
  getStatus: (sessionId: string) =>
    kenticoFreeTrialInstance.post<{ Id: string }, ProvisioningStatusResponse>(
      '/provisioning/status',
      {
        Id: sessionId,
      },
    ),
};
